import { createSelector } from 'reselect'


type Output = {
  id: number
  count: number
  label: string
  value: string
  checked: boolean
}

const selectors = {}

const createFilterListSelector = (filterName: string) => createSelector(
  // TODO: Get typed State
  (state: any) => state.view.smartSearchPage.filters[filterName],
  // TODO: Get typed State
  (state: any) => state.view.smartSearchPage.activeFilters[filterName],
  (allFilters, activeFilters) => (
    allFilters.map(({ id, count, label, value }) => ({
      id,
      count,
      label,
      value,
      checked: activeFilters.includes(value),
    }))
  )
)

// TODO: Get typed State
const getSmartSearchFilterListFromState = (state: any, filterName: string): Output => {
  if (!selectors[filterName]) {
    selectors[filterName] = createFilterListSelector(filterName)
  }

  return selectors[filterName](state)
}


export default getSmartSearchFilterListFromState
